<template>
    <OmniButtonCollection v-bind="[$attrs, $props]">
        <OmniButton :disabled="dispatchRequestRerouteMode"
                    @click="$emit('reloadDispatchRequests')"
                    :spin="isDispatchRequestsLoading"
                    icon="sync-alt"
                    size="lg"
                    variant="info"
        >
            Vernieuwen
        </OmniButton>

        <OmniButton
            v-if="hasAllPermissions(['orders.dispatchrequests.reroute', 'orders.dispatchrequests.reroute.showbutton']) && hasReroutableDispatchRequests"
            @click="$emit('toggleRerouteMode')"
            :disabled="isDispatchRequestsLoading"
            :class="{
                'text-secondary': !dispatchRequestRerouteMode,
                'text-primary': dispatchRequestRerouteMode,
            }"
            icon="route"
            size="lg"
        >
            {{ ((dispatchRequestRerouteMode) ? 'Verlaat' : 'Ga naar') + ' reroute mode' }}
        </OmniButton>

        <OmniButton
            v-if="canAddOrderLines"
            @click="$emit('openFinalDispatchRequestActionModal', 'add-extra-order-lines')"
            :disabled="isDispatchRequestsLoading"
            icon="circle-plus"
            size="lg"
        >
            {{ $t('omt.gui.orders.dispatch-requests.final-action-titles.add-extra-order-lines') }}
        </OmniButton>

        <OmniButton v-if="hasPermission('orders.addorderline')"
                @click="$emit('showModal', 'add-order-line-modal')"
                :disabled="isDispatchRequestsLoading"
                size="lg"
                icon="circle-plus"
                class="text-warning"
        >
            Orderregel toevoegen
        </OmniButton>

        <OmniButton v-if="canInspectMetadata"
                    @click="$emit('showModal', 'inspect-dispatch-request-metadata-modal')"
                    :disabled="isDispatchRequestsLoading"
                    icon="glasses"
                    size="lg"
        >
            Bekijk ruwe data
        </OmniButton>

        <OmniButton v-if="canCreateShippedWithIssues"
                    @click="$emit('openFinalDispatchRequestActionModal', 'create-shipped-with-issues')"
                    :disabled="isDispatchRequestsLoading"
                    icon="far fa-frown"
                    variant="danger"
                    size="lg"
        >
          {{ $t('omt.gui.orders.dispatch-requests.final-action-titles.create-shipped-with-issues') }}
        </OmniButton>
        
        <OmniButton v-if="canCancelLines"
                    @click="$emit('openFinalDispatchRequestActionModal', 'cancel-multiple-lines')"
                    :disabled="isDispatchRequestsLoading"
                    icon="ban"
                    variant="danger"
                    size="lg"
        >
          {{ $t('omt.gui.orders.dispatch-requests.final-action-titles.cancel-multiple-lines') }}
        </OmniButton>
    </OmniButtonCollection>
</template>

<script>
import Vue from 'vue'

import FinalDispatchRequestActions from "../components/FinalDispatchRequestActions.vue";


export default Vue.extend({
    props: {
        salesOrder: {
            type: Object,
            required: true,
            default: () => {},
        },
        isDispatchRequestsLoading: {
            type: Boolean,
            required: true,
            default: true,
        },
        dispatchRequestRerouteMode: {
            type: Boolean,
            required: true,
            default: false,
        },
        hasReroutableDispatchRequests: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        canAddOrderLines() {
            return !!FinalDispatchRequestActions.methods.getApplicableDispatchRequests(
                    this.salesOrder.current_dispatch_requests,
                FinalDispatchRequestActions.methods.getAllowedStatusesForAction('add-extra-order-lines')
                ).length
                && this.hasPermission('orders.addorderline')
        },

        canInspectMetadata() {
          return this.hasPermission('orders.metadata.inspect');
        },

        canCancelLines() {
            return !!FinalDispatchRequestActions.methods.getApplicableDispatchRequests(
                    this.salesOrder.current_dispatch_requests,
                    FinalDispatchRequestActions.methods.getAllowedStatusesForAction('cancel-multiple-lines')
                ).length
                && this.hasPermission('orders.dispatchrequests.cancel');
        },

        canCreateShippedWithIssues() {
            if (
                !this.$store.getters.getFrontendParameterValue('dispatch-requests', 'allow-multiple-shipped-with-issues')
                && this.salesOrder.current_dispatch_requests.some(drq => drq.status === 'shipped-with-issues')
            ) {
                return false
            }

            return !!FinalDispatchRequestActions.methods.getApplicableDispatchRequests(
                    this.salesOrder.current_dispatch_requests,
                    FinalDispatchRequestActions.methods.getAllowedStatusesForAction('create-shipped-with-issues')
                ).length
                && this.hasPermission('orders.addshippedwithissues')
        },
    },
})
</script>
